import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from '../ui/card';
import { TrendingUp, TrendingDown, Target } from 'lucide-react';

interface ROIWidgetProps {
  currentROI: number;
  targetROI?: number;
  period: string;
  showTarget?: boolean;
}

const ROIWidget = ({
  currentROI,
  targetROI,
  period,
  showTarget = false,
}: ROIWidgetProps) => {
  const isPositive = currentROI >= 0;
  const progress = targetROI
    ? Math.min((currentROI / targetROI) * 100, 100)
    : 0;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm font-medium">ROI - {period}</CardTitle>
        <CardDescription>Return on Investment</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            {isPositive ? (
              <TrendingUp className="h-5 w-5 text-green-600" />
            ) : (
              <TrendingDown className="h-5 w-5 text-red-600" />
            )}
            <span
              className={`text-3xl font-bold ${
                isPositive ? 'text-green-600' : 'text-red-600'
              }`}
            >
              {isPositive ? '+' : ''}
              {currentROI.toFixed(2)}%
            </span>
          </div>

          {showTarget && targetROI && (
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Target className="h-4 w-4" />
              <span>Target: {targetROI}%</span>
            </div>
          )}
        </div>

        {showTarget && targetROI && (
          <div className="space-y-2">
            <div className="flex justify-between text-xs text-muted-foreground">
              <span>Progress to Target</span>
              <span>{progress.toFixed(0)}%</span>
            </div>
            <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
              <div
                className={`h-full transition-all ${
                  isPositive ? 'bg-green-500' : 'bg-red-500'
                }`}
                style={{ width: `${Math.abs(progress)}%` }}
              />
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ROIWidget;
